<script>
export default {
    props: {
        selected: {
            default: null
        }
    },
    data() {
        return {
            tabs: [],
            selectedTab: ''
        };
    },

    created() {
        this.tabs = this.$children;
    },

    methods: {
        selectTab(selectedTab) {
            this.tabs.forEach(tab => {
                tab.isActive = (tab.name == selectedTab.name);
            });

            this.$emit('tab-selected', selectedTab);
            this.selectedTab = selectedTab;
        }
    },

    mounted() {
        this.tabs.forEach(tab => {
            if (tab.href == window.location.hash || tab.href ==  this.selected) {
                this.selectTab(tab)
            }
        })
    },

    watch: {
        selected() {
            this.tabs.forEach(tab => {
                if (tab.href == this.selected) {
                    this.selectTab(tab)
                }
            })
        }
    }
}
</script>

<template>
    <div>
        <div class="app-tabs">
            <ul>
                <li v-for="tab in tabs" :class="{ 'is-active': tab.isActive }" :key="`tab${tab.name}`">
                    <a :href="tab.href" @click="selectTab(tab)">{{ tab.name }}</a>
                </li>
            </ul>
        </div>

        <div class="tabs-details">
            <slot></slot>
        </div>
    </div>
</template>

<style lang="scss">
.app-tabs {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    // align-items: stretch;
    // display: -webkit-box;
    // display: -ms-flexbox;
    // display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    font-size: 1rem;

    > ul {
        margin-bottom: 0;
        text-align: center;
        margin-left: 0;
        padding: 0;
        list-style: none;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        border-bottom: 1px solid #dbdbdb;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-flex: 1;
        -ms-flex-positive: 1;
        flex-grow: 1;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        border-left: 1px solid #D1D1D1;

        li {
            display: block;
            background-color: #EBEBEB;
            border-top: 1px solid #D1D1D1;
            border-right: 1px solid #D1D1D1;
            font-weight: bold;
            width: 100%;

            a {
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                color: #455666;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-pack: center;
                -ms-flex-pack: center;
                justify-content: center;
                margin-bottom: -1px;
                padding: .5em 1em;
                vertical-align: top;
                text-decoration: none;
                height: 55px;
            }

            &.is-active a {
                background-color: #69BE28;
                color: white;
            }
        }
    }
}
</style>